<template>
  <el-main class="home">
    <el-image class="docutax-banner" :src="windowSize === 'desktop' ? desktopBanner : mobileBanner" fit="contain" />
    <div class="form-container pa-3">
      <h1>Complete the form below to get started</h1>
      <el-form :model="signupForm" status-icon :rules="validationRules" ref="signupForm">
        <el-form-item label="First Name" required prop="firstName">
          <el-input v-model="signupForm.firstName" placeholder="First Name" />
        </el-form-item>
        <el-form-item label="Last Name" required prop="lastName">
          <el-input v-model="signupForm.lastName" placeholder="Last Name" />
        </el-form-item>
        <el-form-item label="Cell Phone" required prop="cellPhone">
          <el-input v-model="signupForm.cellPhone" type="text" placeholder="Cell Phone" v-mask="'(###) ###-####'"
            inputmode="tel" />
        </el-form-item>
        <el-form-item label="Email Address (optional)" prop="emailAddress">
          <el-input v-model="signupForm.emailAddress" type="email" placeholder="Email Address (optional)" />
        </el-form-item>
        <el-row type="flex" justify="center">
          <el-button v-loading="saving" class="ma-3" type="primary" round @click="onSubmit">Submit</el-button>
        </el-row>
        <small class="text-italic">
          By completing this form, you agree to receive SMS messages from M &amp; M Tax. Message and
          data rates may apply.
        </small>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import api from '@/api';

const desktopBanner = require('@/assets/docutaxbanner.jpg');
const mobileBanner = require('@/assets/docutaxbannermobile.jpg');

export default {
  components: {},
  beforeMount() {
    window.addEventListener('resize', this.onResize.bind(this));
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize.bind(this));
  },
  data() {
    return {
      desktopBanner,
      mobileBanner,
      windowSize: 'desktop',
      saving: false,
      signupForm: {
        firstName: '',
        lastName: '',
        cellPhone: '',
        emailAddress: '',
      },
      validationRules: {
        firstName: [{ required: true, message: 'First Name is required', trigger: 'blur' }],
        lastName: [{ required: true, message: 'Last Name is required', trigger: 'blur' }],
        cellPhone: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('Cell phone number is required.'));
              } else if (!value.match(/^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/i)) {
                callback(new Error('Please enter a valid phone number in (999) 999-9999 format'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        emailAddress: [
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else if (!value.match(/^.+@.+\..+$/i)) {
                callback(new Error('Please enter a valid email address'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  mounted() {
    this.onResize();
    this.initializeFormWithQueryParams();
  },
  methods: {
    async onSubmit() {
      try {
        await this.$refs.signupForm.validate();
      } catch (e) {
        console.warn('validation failed', this.signupForm);
        return;
      }

      try {
        this.saving = true;
        const result = await api.docutax.signup(this.signupForm);

        this.$router.push({
          name: 'verification',
          params: {
            clientId: result.data.id,
          },
        });
      } catch (e) {
        // do a toast
        console.error('signup error', e);
      } finally {
        this.saving = false;
      }
    },
    onResize() {
      if (window.innerWidth >= 400) {
        this.windowSize = 'desktop';
      } else {
        this.windowSize = 'mobile';
      }
    },
    initializeFormWithQueryParams() {
      const params = this.$route.query;
      console.info('params', params);
      if (params && params.firstName) {
        this.signupForm.firstName = decodeURI(params.firstName);
      }
      if (params && params.lastName) {
        this.signupForm.lastName = decodeURI(params.lastName);
      }
      if (params && params.cellPhone) {
        this.signupForm.cellPhone = decodeURI(params.cellPhone);
      }
      if (params && params.emailAddress) {
        this.signupForm.emailAddress = decodeURI(params.emailAddress);
      }
    },
  },
};
</script>

<style lang="scss">
.el-main.home {
  align-items: center;
  padding: 0 0 50px 0;

  .docutax-banner {
    width: 100%;
  }

  .form-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .el-form {
      width: 100%;
      max-width: 600px;
    }
  }
}
</style>
